<app-not-logged-in *ngIf="!user?.admin" i18n-message="not-logged-in message admin control panel"
                   message="You need to login as an admin, before you can see the admin panel."></app-not-logged-in>
<div *ngIf="fetchUserActionResult && fetchUserActionResult.errorMessage" class="container bg-container p-1">
  <div class="alert alert-danger">{{fetchUserActionResult.errorMessage}}</div>
</div>
<div *ngIf="user?.admin" class="parent">
  <router-outlet></router-outlet>
</div>
